import { Alert } from 'antd';
import type { Insight } from '../contract';
import styles from '../style.module.scss';

const ALERT_TYPE: Record<Insight['severity'], 'error' | 'warning' | 'info'> = {
  danger: 'error',
  warn: 'warning',
  info: 'info',
};

interface Props {
  insights: Insight[];
  /** Tổng quan tối đa 5, Drawer tối đa 6 (đặc tả §8). */
  max?: number;
  title?: string;
}

/** Thẻ "Nhận xét": mỗi nhận xét một Alert theo mức (danger → error, warn → warning, info → info). */
const InsightsCard = ({ insights, max = 5, title = 'Nhận xét' }: Props) => {
  const list = (insights || []).slice(0, max);
  return (
    <section className={styles.card} aria-label={title}>
      <h2 className={styles.cardTitle}>{title}</h2>
      {list.length === 0 ? (
        <p className={styles.muted}>Chưa có nhận xét nào cho phạm vi này.</p>
      ) : (
        <div className={styles.insights}>
          {list.map((it, i) => (
            <Alert
              key={`${it.code}-${i}`}
              type={ALERT_TYPE[it.severity] || 'info'}
              showIcon
              message={
                <span>
                  <strong>{it.title}</strong>
                  {it.text ? <span className={styles.insightText}> {it.text}</span> : null}
                </span>
              }
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default InsightsCard;
